module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon28.fa1b87c7.png";